import { FC, HTMLAttributes } from "react";
import { useAppDispatch, useAppSelector } from "toolkit/hooks";
import { dowloadDocument, updateDocument } from "toolkit/steps/stepTwo/objectsRegister/objectsRegister.thunks";
import { ReactComponent as Refresh } from "images/Refresh.svg";
import { ReactComponent as Download } from "images/downloadArrowOnCircle.svg";
import styles from "./Menu.module.sass";
import cn from "classnames";

interface MenuProps extends HTMLAttributes<HTMLDivElement> {
	object: any;
}

export const Menu: FC<MenuProps> = ({ className, object }) => {
	const dispatch = useAppDispatch();
	const author = useAppSelector((state) => state.profile.profile.id);

	const documentUpdateHandler = (files: FileList | null) => {
		if (author) dispatch(updateDocument({ objectId: object.id, file: files![0] }));
	};

	const downloadHandler = () => {
		dispatch(dowloadDocument(object.document));
	};

	return (
		<div className={styles["menu-wrp"]}>
			<button className={cn("link", styles.title)}>{object.document.fullName}</button>
			<div className={cn(styles.menu, className)}>
				<label className={styles["menu-btn"]} htmlFor={`changeDoc-${object.id}`}>
					<div>
						<Refresh className={styles.blue} />
					</div>
					Обновить документ
				</label>
				<input
					onChange={(e) => documentUpdateHandler(e.target.files)}
					type="file"
					id={`changeDoc-${object.id}`}
					className="none"
					accept=".docx, .pdf, .rtf"
				/>
				<button onClick={downloadHandler} className={styles["menu-btn"]}>
					<div>
						<Download className={styles.green} />
					</div>
					Скачать документ
				</button>
				{/* <button onClick={documentDeletionHandler} className={styles["menu-btn"]}>
                    <div><TrashCan className={styles.trashCan} /></div>
                    Удалить документ
                </button> */}
			</div>
		</div>
	);
};
